import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService, PlatformService} from '../services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private platformService: PlatformService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | boolean {
    const isAuth = this.authService.isAuthenticated();

    return this.platformService.getPlatformStatus().pipe(
      map((isInApp: boolean) => {
        console.log(`${state.url}`)
        const keep = `?go=${encodeURIComponent(state.url)}`

        if(isInApp){
          if (state.url != '/app' && state.url != '/paysliprequest') {
            this.router.navigateByUrl('app');
            return false
          }
        }
        else if (state.url.includes('/app')) {
          if (!isInApp) {
            this.router.navigateByUrl(`login`);
            return false;
          }
        }
        else if (state.url === '/forgot-password' || state.url === '/redirect') {
          if (isAuth) {
            this.router.navigateByUrl('payroll/admin');
            return false;
          } else {
            this.authService.removeSession();
            this.router.navigateByUrl(`login`);
            return false;
          }
        }
        else if (state.url.indexOf('/login') === 0) {
          if (isAuth) {
            this.router.navigateByUrl('payroll/admin');
            return false;
          } 
        }
        else {
          if (!isAuth) {
            this.authService.removeSession();
            this.router.navigateByUrl(`login${keep}`);
            return false;
          }
        }

        return true
      })
    )

  }
}